import React from 'react';

import { Button, Modal, Text } from '@components/common';

interface Props {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  authMethodName: string;
  isLoading?: boolean;
}

export const AuthMethodRemovalModal: React.FC<Props> = ({
  open,
  onClose,
  onConfirm,
  authMethodName,
  isLoading = false
}) => {
  if (!open) return null;

  return (
    <Modal
      title={`Disable ${authMethodName}?`}
      onClose={onClose}
      renderFooter={() => (
        <>
          <Button onClick={onClose}>Don't disable</Button>
          <Button primary onClick={onConfirm} disabled={isLoading}>
            Confirm & disable
          </Button>
        </>
      )}
    >
      <Text h='400' className='mb-4'>
        This changes how all account members can access the workspace. Users currently signed in with {authMethodName}{' '}
        will be logged out immediately.
      </Text>
    </Modal>
  );
};
